import { useCallback, useEffect, useState } from 'react';
import { withMake, withModel } from '../policies/catalogue-additions';
import { addTruckMake, addTruckModel, listTruckMakes, type TruckMakeView } from '../truck-models.api';

export type TruckCatalogueState = { status: 'loading' } | { status: 'loaded'; makes: TruckMakeView[] } | { status: 'error' };

/** The make/model catalogue, fetched whole (a small fixed catalogue), and the two adds, which return the catalogue's spelling of what was added. */
export function useTruckCatalogue() {
  const [state, setState] = useState<TruckCatalogueState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    listTruckMakes()
      .then((makes) => {
        if (!cancelled) setState({ status: 'loaded', makes });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error' });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const addMake = useCallback(async (name: string): Promise<string> => {
    const added = await addTruckMake({ name });
    setState((current) => (current.status === 'loaded' ? { status: 'loaded', makes: withMake(current.makes, added) } : current));
    return added.name;
  }, []);

  const addModel = useCallback(async (makeId: string, name: string): Promise<string> => {
    const added = await addTruckModel(makeId, { name });
    setState((current) => (current.status === 'loaded' ? { status: 'loaded', makes: withModel(current.makes, makeId, added) } : current));
    return added.name;
  }, []);

  return { state, addMake, addModel };
}
